// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-boxs ._kwai-player-poster_uxc1a_19 {\n  display: block;\n  width: 10.20833vw;\n  height: 13.69792vw;\n  margin: 0 auto;\n  background: #f2f2f2 center/100% no-repeat;\n  object-fit: cover;\n  border-radius: 0.41667vw;\n}\n.video-boxs video {\n  display: block;\n  width: 10.20833vw;\n  height: 100%;\n  margin: 0 auto;\n  background: #f2f2f2 center/100% no-repeat;\n  object-fit: cover;\n  max-width: 39.0625vw;\n  border-radius: 0.41667vw;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
